import React, { useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { COUNTRIES, COUNTRY_MAP } from "../countries";

export default function SchoolInfoStep({ formData, updateField, onNext }) {
  const canProceed =
    formData.schoolName.trim() && formData.email.trim();

  // Auto-detect country from IP on first mount
  useEffect(() => {
    if (formData.country) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3000);

    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => {
        clearTimeout(timer);
        if (data.country_code && COUNTRY_MAP[data.country_code]) {
          updateField("country", data.country_code);
        }
      })
      .catch(() => {});

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectedCountry = COUNTRY_MAP[formData.country];
  const dialCode = selectedCountry?.dialCode || "";

  return (
    <div>
      <div className="step-title">School Information</div>

      <div className="p-field">
        <label htmlFor="schoolName">School Name *</label>
        <InputText
          id="schoolName"
          value={formData.schoolName}
          onChange={(e) => updateField("schoolName", e.target.value)}
          placeholder="e.g. Springfield Academy"
        />
      </div>

      <div className="p-field">
        <label htmlFor="email">School Email *</label>
        <InputText
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => updateField("email", e.target.value)}
          placeholder="info@school.com"
        />
      </div>

      <div className="p-field">
        <label htmlFor="country">Country</label>
        <Dropdown
          id="country"
          value={formData.country}
          options={COUNTRIES}
          optionLabel="name"
          optionValue="code"
          onChange={(e) => updateField("country", e.value)}
          placeholder="Select a country"
          filter
          filterBy="name"
        />
      </div>

      <div className="p-field">
        <label htmlFor="phone">Phone</label>
        <div className="p-inputgroup">
          {dialCode && (
            <span className="p-inputgroup-addon">{dialCode}</span>
          )}
          <InputText
            id="phone"
            value={formData.phone}
            onChange={(e) => updateField("phone", e.target.value)}
            placeholder="3001234567"
          />
        </div>
      </div>

      <div className="p-field">
        <label htmlFor="address">Address</label>
        <InputText
          id="address"
          value={formData.address}
          onChange={(e) => updateField("address", e.target.value)}
        />
      </div>

      <div className="step-actions">
        <span />
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={onNext}
          disabled={!canProceed}
        />
      </div>
    </div>
  );
}
